const eventConfig = {
    event: {
        filterLayout: 'EventFilterDefaultLayout',
        listLayout: 'EventListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getEvent',
        pageRow: 10,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
        },
        sortOptions: {},
        startSort: {},
        deleteFunc: 'deleteEvent',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "비밀번호가 틀리거나 삭제 권한이 없습니다.",
            '-3': "노출중인 이벤트는 삭제 할 수 없습니다.",
            '-5': "이미 삭제된 이벤트 입니다.",
        },
        deleteModalName: 'event-delete-modal',
        keyName: 'e_idx'
    },
    eventCreate: {
        getFunc: '',
        detailApiParamSet: {},
        writeFunc: 'createEvent',
        writeLayouts: ['EventWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: 'e_subject',
            link: 'e_url',
            showDate: '',
            showStartDate: 'e_startdate',
            showEndDate: 'e_enddate',
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'event', required: true, validatorMsg: '배너이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': '이벤트 생성 권한이 없습니다.',
            '-3': '등록에 실패했습니다. 노출기간을 확인해주세요.',
        },
        writeFailMsg: '등록에 실패했습니다. 잠시 후 다시 시도해주세요.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteEvent',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "비밀번호가 틀리거나 삭제 권한이 없습니다.",
            '-3': "노출중인 이벤트는 삭제 할 수 없습니다.",
            '-5': "이미 삭제된 이벤트 입니다.",
        },
        deleteModalName: 'event-delete-modal',
        keyName: 'e_idx',
    },
    eventUpdate: {
        getFunc: 'getEvent',
        detailApiParamSet: {ip: 0},
        writeFunc: 'updateEvent',
        writeLayouts: ['EventWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            title: 'e_subject',
            link: 'e_url',
            showDate: '',
            showStartDate: 'e_startdate',
            showEndDate: 'e_enddate',
        },
        allSetData: false,
        fileInfo: [
            {fileName: 'mainFile', fileType: 'event', required: true, validatorMsg: '배너이미지를 추가해주세요.',},
        ],
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {
            '-2': '이벤트 생성 권한이 없습니다.',
            '-3': '등록에 실패했습니다. 노출기간을 확인해주세요.',
        },
        writeFailMsg: '등록에 실패했습니다. 잠시 후 다시 시도해주세요.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        deleteFunc: 'deleteEvent',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-2': "비밀번호가 틀리거나 삭제 권한이 없습니다.",
            '-3': "노출중인 이벤트는 삭제 할 수 없습니다.",
            '-5': "이미 삭제된 이벤트 입니다.",
        },
        deleteModalName: 'event-delete-modal',
        keyName: 'e_idx',
    },
};

export default {
    methods: {
        returnEventConfig(type) {
            return eventConfig[type];
        },
    },
    filterConfig: {
        su: { //제목
            type: 'query',
            classname: 'searchInput'
        },
    }
}
